import React from 'react';
import PropTypes from 'prop-types';
import './ComboButton.scss';


import Button from 'Components/Button';

const ComboButton = ({
  firstButtonExtraClass,
  firstButtonType,
  user,
  firstActionMethod,
  firstMethodParam,
  firstButtonText,
  secondButtonExtraClass,
  secondButtonType,
  secondActionMethod,
  secondMethodParam,
  secondButtonText,
  ...props
}) => {
  return (
    <div className="valuefix">
      <Button
        extraClass={firstButtonExtraClass}
        category={firstButtonType}
        action={firstActionMethod}
        url={firstMethodParam}
        disabled={props.isDisabled}
      >
        {firstButtonText}
      </Button>

      {
        user && user.parsedPermissions && user.parsedPermissions.search &&
        user.parsedPermissions.queue.addManualTransaction &&
        (
          <Button
            style={{ marginLeft: 10 }}
            extraClass={secondButtonExtraClass}
            category={secondButtonType}
            action={secondActionMethod}
            url={secondMethodParam}
            disabled={props.isDisabled}
          >
            {secondButtonText}
          </Button>)
      }
    </div>
  );
};

ComboButton.propTypes = {

};

ComboButton.defaultProps = {
  user: '',
};

export default ComboButton;
